<script>
import {getLocalItem,setLocalItem} from '@/untils/common';
import wx from "weixin-js-sdk";
export default {
  name:'index',
  data(){
    return{
      textFlag:false,
      textContent:'无openid，请退出公众号，重新从菜单进入',
    }
  },
  methods:{
    getConfig() {
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                  'scanQRCode',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                console.log('wx.ready----SDK初始化')
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    getInitLocation(oid){
      // if(getLocalItem('user_id')){
      //   // 专管员 和 技术人员 = techHome
      //   // 站主 和 销售员 = userHome
      //   if(getLocalItem('local_role')){
      //     if(getLocalItem('local_role')==='代销者'){
      //       this.$router.push({path:'/userHome',query:{openid:oid}});
      //     }else if(getLocalItem('local_role')==='销售员'){
      //       this.$router.push({path:'/userHome',query:{openid:oid}});
      //     }
      //   }else{
      //     if(getLocalItem('roles')){
      //       if(getLocalItem('roles').indexOf('专管员')!==-1){
      //         this.$router.push({path:'/techHome',query:{openid:oid}});
      //       }else if(getLocalItem('roles').indexOf('维修')!==-1){
      //         this.$router.push({path:'/techHome',query:{openid:oid}});
      //       }else if(getLocalItem('roles').indexOf('代销者')!==-1){
      //         this.$router.push({path:'/userHome',query:{openid:oid}});
      //       }else if(getLocalItem('roles').indexOf('销售员')!==-1){
      //         this.$router.push({path:'/userHome',query:{openid:oid}});
      //       }
      //     }
      //   }
      // }else{
      this.$router.push({path:'/login',query:{openid:oid}});
      // }
    }
  },
  created(){
    // 获取正常openid为字符位数28
    let url_openid = this.$route.query.openid;
    if(url_openid){
      if(url_openid.length<28){
        this.textFlag = true;
        this.$toast('无openid，请退出公众号，重新进');
        return false;
      }else{
        setLocalItem('open_id',url_openid);
        this.getInitLocation(url_openid);
      }
    }else{
      this.textFlag = true;
      this.$toast('无openid，请退出公众号，重新进');
      return false;
    }
    // 微信验签
    this.getConfig();
  }
}
</script>
<template>
  <div class="bg">
    <div class="load">
      <van-loading size="25px" type="spinner" text-size="15px" color="#e62d2d">加载中...</van-loading>
      <div v-show="textFlag">{{textContent}}</div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.bg{
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size:26px;
  color: #333;
  .load{
    text-align: center;
    margin-top: 150px;
  }
}
</style>